var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-container",on:{"dblclick":_vm.revertMap}},[_c('div',{ref:"map_ref",staticClass:"com-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }